var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoginPasswordError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_password_error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,3 C14.8669346,3 16.7857143,4.79182182 16.7857143,7.00236948 L16.785,9 L18.0081158,9 C19.1082031,9 20,9.90195036 20,11.0085302 L20,18.9914698 C20,20.1007504 19.1066027,21 18.0081158,21 L6.99188419,21 C5.89179693,21 5,20.0980496 5,18.9914698 L5,11.0085302 C5,9.8992496 5.89339733,9 6.99188419,9 L8.214,9 L8.21428571,7.00236948 C8.21428571,4.79192185 10.1378816,3 12.5,3 Z M12.5,13 C11.3165327,13 10.3571429,13.8954305 10.3571429,15 C10.3571429,16.1045695 11.3165327,17 12.5,17 C13.6834673,17 14.6428571,16.1045695 14.6428571,15 C14.6428571,13.8954305 13.6834673,13 12.5,13 Z M12.5,5 C11.3195974,5 10.3571429,5.89812584 10.3571429,7.00236948 L10.357,9 L14.642,9 L14.6428571,7.00236948 C14.6428571,5.89616855 13.6832284,5 12.5,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-1",
    transform: "translate(-1062.000000, -1039.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_password_error",
    transform: "translate(1057.000000, 1036.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Depth",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#42526E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "N500",
    fill: "#C60000",
    mask: "url(#mask-2)",
    points: "-1 24 25 24 25 0 -1 0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginPasswordError);
export default __webpack_public_path__ + "static/media/icon_login_password_error.d905860bfa5d32e7f8684981998fed0e.svg";
export { ForwardRef as ReactComponent };